module.exports = __webpack_public_path__ + "img/clients-active.aec2e634.svg";